// extracted by mini-css-extract-plugin
export default {"pannel_wrapper":"panel_pannel_wrapper__2JN-V","title_wrapper":"panel_title_wrapper__BEZ7Y","btn_close":"panel_btn_close__XeTIn"};